import * as React from "react";
import { Alert } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import { useClientLock } from "contexts/ClientLockContext";

/** Shown to users who cannot change a locked account. */
const LOCKED_MESSAGE = "This account is locked. Please contact an Administrator.";

/** Shown to Super Admins, whose controls stay enabled, so the warning does not read as a bug. */
const SUPER_USER_LOCKED_MESSAGE = "This account is locked. As a System Admin you can still make changes.";

/** Sits next to the client name in the Client Details header. Renders nothing unless the account is locked. */
const ClientLockedWarning: React.FC = () => {
  const { isConfigLocked, isReadOnly } = useClientLock();
  if (!isConfigLocked) {
    return null;
  }
  return (
    <Alert
      severity="warning"
      icon={<LockIcon fontSize="inherit" />}
      data-testid="client-locked-warning"
      sx={{ py: 0, alignItems: "center" }}
    >
      {isReadOnly ? LOCKED_MESSAGE : SUPER_USER_LOCKED_MESSAGE}
    </Alert>
  );
};

export { ClientLockedWarning, LOCKED_MESSAGE, SUPER_USER_LOCKED_MESSAGE };
